import {ImmutableStore} from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';
import moment from 'moment';
import Immutable from 'immutable';
import { startOfDay } from '../utils/Date';
import { parseJsonIfNeeded } from '../utils/UrlParamParsers';
import { GuideDelivery } from '../model/Guide';

function defaultState() {
  return {
    loading: false,
    deviceData: [],
    heatMapData: [],
    funnelHistory: [],
    actionsHistory: [],
    totals: {
      guidesStarted: 0,
      guidesCompleted: 0,
      tookAction: 0,
      openedAccounts: 0
    },
    location: '',
    guideType: 'both',
    guideDelivery: GuideDelivery.branch,
    actionType: 'percentage',
    deviceType: 'percentage',
    deviceFilter: 'type',
    selectedBranchHierarchy: null,
    customerType: 'both'
  };
}

class TrafficSummaryStore extends ImmutableStore {
  static storeName = 'TrafficSummaryStore';

  static handlers = {
    [Actions.TRAFFIC_SUMMARY_DATA_CHANGED]: 'handleTrafficSummaryDataChanged',
    [Actions.TRAFFIC_SUMMARY_QUERY_CHANGED]: 'handleTrafficSummaryQueryChanged',
    [Actions.AUTHENTICATION_CHECK_COMPLETED]: 'handleAuth',
    [Actions.AUTHENTICATION_COMPLETED]: 'handleAuth'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.startDate = startOfDay().subtract(1, 'month').toDate();
    this.endDate = startOfDay().toDate();
    this.setState(defaultState());
  }

  handleTrafficSummaryQueryChanged(query) {
    const defaults = defaultState();
    const {
      startDate = startOfDay().subtract(1, 'month').toDate(),
      endDate = startOfDay().toDate(),
      guideType = this.getGuideType(),
      guideDelivery = this.getGuideDelivery(),
      deviceType = defaults.deviceType,
      actionType = defaults.actionType,
      deviceFilter = defaults.deviceFilter,
      customerType = defaults.customerType,
      selectedBranchHierarchy
    } = query;

    this.mergeState({
      actionType,
      deviceType,
      guideType,
      guideDelivery,
      deviceFilter,
      customerType,
      selectedBranchHierarchy: parseJsonIfNeeded(selectedBranchHierarchy)
    });

    if (startDate || endDate) {
      this.startDate = startDate ? new Date(startDate) : this.startDate;
      this.endDate = endDate ? new Date(endDate) : this.endDate;
      this.emitChange();
    }
  }

  handleTrafficSummaryDataChanged(payload) {
    const {deviceData, totalData, heatMapData, loading = false} = payload;

    console.log('Updating traffic store state', payload);

    const state = {
      loading
    };

    if (deviceData) {
      deviceData.forEach(d => {
        const td = moment();
        td.year(d._id.year);
        td.dayOfYear(d._id.day);
        d.timestamp = td.toDate();
      });
      state.deviceData = Immutable.fromJS(deviceData || []).sortBy(d => d.get('timestamp'));
    }

    if (totalData) {
      state.totals = totalData;
      state.funnelHistory = totalData.data;
      state.actionsHistory = totalData.actions;
    }

    if (heatMapData) {
      state.heatMapData = heatMapData;
    }

    this.mergeState(state);
  }

  isLoading() {
    return this.get('loading');
  }

  getGuideType() {
    return this.get('guideType');
  }

  getGuideDelivery() {
    return this.get('guideDelivery');
  }

  getDeviceFilter() {
    return this.get('deviceFilter');
  }

  getDeviceType() {
    return this.get('deviceType');
  }

  getDeviceData() {
    return this.get('deviceData').toJS();
  }

  getTotalData() {
    return this.get('totals').toJS();
  }

  getHeatMapData() {
    return this.get('heatMapData').toJS();
  }

  getCustomerType() {
    return this.get('customerType');
  }

  getSelectedDateRange() {
    return {
      start: this.startDate,
      end: this.endDate
    };
  }

  handleAuth = ({ clientInfo: { branchHierarchyTerms, branchHierarchy } = {} } = {}) => {
    if (branchHierarchyTerms && branchHierarchy) {
      this.mergeState({
        branchHierarchy,
        branchHierarchyTerms
      });
    }
  };

  getBranchHierarchy = () => {
    return this.get('branchHierarchy');
  };

  getBranchHierarchyTerms = () => {
    return this.get('branchHierarchyTerms');
  };

  getSelectedBranchHierarchy = () => {
    return this.get('selectedBranchHierarchy');
  };

  setDeviceFilter(deviceFilter) {
    this.mergeState({
      deviceFilter
    });
  }

  getFunnelHistory() {
    return this.get('funnelHistory').toJS();
  }

  getActionsHistory() {
    return this.get('actionsHistory').toJS();
  }

  rehydrate(state) {
    state._state.deviceData.forEach(e => {
      e.timestamp = new Date(e.timestamp);
    });
    super.rehydrate(state._state);

    this.startDate = new Date(state.startDate);
    this.endDate = new Date(state.endDate);
  }

  dehydrate() {
    return {
      _state: this._state,
      startDate: this.startDate,
      endDate: this.endDate
    };
  }
}

export default TrafficSummaryStore;



// WEBPACK FOOTER //
// ./src/stores/TrafficSummaryStore.js